/**
 * [polecenie właściciela 2026-09-14] PUBLICZNE LINKI DO SZKOLEŃ.
 *
 * Dwie warstwy w jednym module:
 *  • administracyjna — na wspólnej instancji `api` (JWT z ciasteczka, interceptory jak wszędzie);
 *  • publiczna — na OSOBNEJ instancji axios BEZ `withCredentials` i BEZ interceptorów odpowiedzi.
 *    Powód: interceptor wspólnej instancji na 401 odświeża sesję aplikacji i przekierowuje do logowania,
 *    a strona publiczna logowania NIE MA (polecenie: „bez opcji logowania”). Backend i tak nie oddaje tu 401
 *    (zły kod / zła sesja = 403, poza okresem = 410), ale osobna instancja domyka to także na wypadek
 *    błędu serwera — żadna odpowiedź publicznej końcówki nie wyrzuci przeglądarki na ekran logowania.
 *    Sesja publiczna to podpisany HMAC token w nagłówku `X-Kod-Sesji` (trzymany w pamięci przeglądarki).
 */
import axios from "axios";

export const NAGLOWEK_SESJI = "X-Kod-Sesji";

export function attach(api) {
    const publiczne = axios.create({
        baseURL: api.defaults?.baseURL,
        timeout: 30000,
        withCredentials: false,
    });
    const zSesja = (sesja, extra = {}) => ({ ...extra, headers: { ...(extra.headers || {}), [NAGLOWEK_SESJI]: sesja || "" } });
    const t = (token) => encodeURIComponent(token || "");

    return {
        // ── administrator (api/elearning/publiczne-linki) ──
        getPubliczneLinkiKursu: (courseId) => api.get(`/elearning/publiczne-linki/kurs/${courseId}`),
        utworzPublicznyLink: (courseId, dane) => api.post(`/elearning/publiczne-linki/kurs/${courseId}`, dane),
        edytujPublicznyLink: (linkId, dane) => api.put(`/elearning/publiczne-linki/${linkId}`, dane),
        przelaczPublicznyLink: (linkId) => api.patch(`/elearning/publiczne-linki/${linkId}/aktywny`),
        getKodyPublicznegoLinku: (linkId) => api.get(`/elearning/publiczne-linki/${linkId}/kody`),
        generujKodyPublicznegoLinku: (linkId, dane) => api.post(`/elearning/publiczne-linki/${linkId}/kody`, dane),
        // [2026-09-18] kod ogólny linku („kod szkolenia dla każdego”, wielokrotnego użytku) — idempotentnie
        generujKodOgolnyPublicznegoLinku: (linkId) => api.post(`/elearning/publiczne-linki/${linkId}/kod-ogolny`),
        wyslijKodPublicznegoLinku: (linkId, kodId, kanaly) => api.post(`/elearning/publiczne-linki/${linkId}/kody/${kodId}/wyslij`, kanaly),
        usunKodPublicznegoLinku: (linkId, kodId) => api.delete(`/elearning/publiczne-linki/${linkId}/kody/${kodId}`),
        getPracownicyDoKodu: (search) => api.get("/elearning/publiczne-linki/pracownicy", { params: { search: search || undefined } }),

        // ── strona publiczna (api/public/szkolenia) ──
        otworzPubliczneSzkolenie: (token) => publiczne.get(`/public/szkolenia/${t(token)}`),
        zalogujKodemPublicznegoSzkolenia: (token, kod) => publiczne.post(`/public/szkolenia/${t(token)}/kod`, { kod }),
        trescPublicznegoSzkolenia: (token, sesja) => publiczne.get(`/public/szkolenia/${t(token)}/tresc`, zSesja(sesja)),
        zaliczLekcjePublicznegoSzkolenia: (token, sesja, lessonId) =>
            publiczne.put(`/public/szkolenia/${t(token)}/lekcje/${lessonId}/ukoncz`, null, zSesja(sesja)),
        oddajQuizPublicznegoSzkolenia: (token, sesja, odpowiedzi) =>
            publiczne.post(`/public/szkolenia/${t(token)}/quiz`, { odpowiedzi }, zSesja(sesja)),
        ukonczPubliczneSzkolenie: (token, sesja) => publiczne.post(`/public/szkolenia/${t(token)}/ukoncz`, null, zSesja(sesja)),
        zalacznikPublicznegoSzkoleniaBlob: (token, sesja, attachmentId) =>
            publiczne.get(`/public/szkolenia/${t(token)}/zalaczniki/${attachmentId}`, zSesja(sesja, { responseType: "blob" })),
    };
}
